/**
 *  @class
 *  @function ProductCompareTable
 */
if (!customElements.get('product-compare-table')) {
  class ProductCompareTable extends HTMLElement {
    constructor() {
      super();
      /** @type {HTMLElement | null} */
      this.container = null;
      /** @type {string[]} */
      this.handles = [];
    }

    connectedCallback() {
      // 首先尝试查找compare-lightbox--table，如果没有找到，尝试查找compare-lightbox--data
      this.container = this.querySelector('.compare-lightbox--table');
      if (!this.container) {
        this.container = this.querySelector('.compare-lightbox--data');
        console.log('Using compare-lightbox--data as container');
      }

      // 添加调试信息
      this.productId = this.dataset.productId || '';
      this.max = this.dataset.max;
      console.log('ProductCompareTable initialized with productId:', this.productId);

      // 显示localStorage中的比较数据
      const compareData = localStorage.getItem('compare-products-vision');
      console.log('LocalStorage compare data:', compareData);
      if (compareData) {
        try {
          const compareProducts = JSON.parse(compareData);
          console.log('Parsed compare products:', compareProducts);
        } catch (error) {
          console.error('Error parsing compare data:', error);
        }
      }

      this.renderTable();
      this.addEventListeners();
    }
    addEventListeners() {
      this.addEventListener('render-product-compare-modal', this.renderTable.bind(this));
    }

    renderTable() {
      this.classList.add('loading');
      this.handles = this.getCompareHandles();
      this.fetchProducts();
    }

    getSelectedProducts() {
      const stored = window.localStorage.getItem('compare-products-vision');
      return stored ? JSON.parse(stored) : [];
    }
    getCompareHandles() {
      const url = new URL(window.location.href);
      const handles = url.searchParams.get('compare');

      if (typeof handles === 'string' && handles !== '') {
        return handles.split(',');
      }

      return [];
    }
    async fetchProducts() {
      // 首先检查URL参数中的产品handles
      const urlHandles = this.handles;

      // 如果URL中有产品handles，使用这些handles
      // 否则，使用localStorage中选择的产品
      let compareProducts;
      if (urlHandles.length > 0) {
        // 将handles转换为产品对象数组，根据当前语言环境构建URL
        const locale = window.theme ? window.theme.locale : { iso_code: 'en' };
        const isEnglish = locale.iso_code === 'en';
        compareProducts = urlHandles.map(handle => ({
          handle: handle,
          url: isEnglish ? `/en/products/${handle}` : `/products/${handle}`,
          id: ''
        }));
      } else {
        compareProducts = this.getSelectedProducts();
      }

      let returnHtml = '';
      /** @type {Record<string, string>} */
      let returnArray = {};

      console.log('Selected products for comparison:', compareProducts);

      // 如果没有选择产品，直接返回
      if (compareProducts.length === 0) {
        console.log('No products selected for comparison');
        this.classList.remove('loading');
        return;
      }

      // 确保container已正确初始化
      if (!this.container) {
        console.error('Container element not found');
        this.classList.remove('loading');
        return;
      }

      try {
        await Promise.all(compareProducts.map(async (/** @type {{url: string, handle: string, id: string}} */ product) => {
          console.log('\n=== Fetching product:', product.handle, 'for comparison ===');

          // 直接使用Shopify的section端点来获取产品比较数据
          const locale = window.theme ? window.theme.locale : { iso_code: 'en' };
          const isEnglish = locale.iso_code === 'en';
          const sectionUrl = isEnglish ? `/en/products/${product.handle}?section_id=main-product-compare` : `/products/${product.handle}?section_id=main-product-compare`;
          console.log(`Trying section URL: ${sectionUrl}`);

          try {
            const response = await fetch(sectionUrl, {
              method: 'GET'
            });
            const text = await response.text();

            // 检查返回的HTML内容
            console.log('Response status:', response.status);
            console.log('Response URL:', response.url);
            console.log('Response HTML length:', text.length);

            // 检查HTML中是否包含main-product-compare
            console.log('HTML contains main-product-compare:', text.includes('main-product-compare'));
            console.log('HTML contains compare-lightbox--table:', text.includes('compare-lightbox--table'));
            console.log('HTML contains compare-lightbox--data:', text.includes('compare-lightbox--data'));

            // 提取前1000个字符用于调试
            if (text.length > 1000) {
              console.log('First 1000 chars of response:', text.substring(0, 1000));
            }

            // 直接使用getSectionInnerHTML提取内容，现在它能够处理多种情况
            const extractedHtml = this.getSectionInnerHTML(text, '.compare-lightbox--table');
            console.log('Extracted HTML length:', extractedHtml.length);

            if (extractedHtml.length > 0) {
              returnArray[product.id] = extractedHtml;
              console.log('Successfully fetched product data for:', product.handle);
            } else {
              console.error('Failed to extract valid HTML for product:', product.handle);
              const errorText = window.theme && window.theme.strings && window.theme.strings.compare ? window.theme.strings.compare.errorLoadingProductData : 'Fehler beim Laden der Produktdaten für';
              returnArray[product.id] = `<div class="compare-lightbox--table"><div class="compare-lightbox--row">${errorText} ${product.handle || product.id}</div></div>`;
            }
          } catch (error) {
            console.error('Error fetching product data:', error);
            const errorText = window.theme && window.theme.strings && window.theme.strings.compare ? window.theme.strings.compare.errorLoadingProductData : 'Fehler beim Laden der Produktdaten für';
            returnArray[product.id] = `<div class="compare-lightbox--table"><div class="compare-lightbox--row">${errorText} ${product.handle || product.id}</div></div>`;
          }
        }));

        // 构建最终的HTML
        compareProducts.forEach((/** @type {{url: string, handle: string, id: string}} */ product) => {
          if (returnArray[product.id]) {
            returnHtml += returnArray[product.id];
          }
        });

        console.log('\n=== Final HTML to render (length:', returnHtml.length, ') ===');

        // 设置列数并更新内容
        if (this.container && this.container instanceof HTMLElement) {
          // 确保container是正确的元素
          console.log('Updating container:', this.container);

          // 检查container是否有style属性
          if (this.container.style) {
            this.container.style.setProperty('--columns', compareProducts.length);
          }

          // 更新container的内容
          this.container.innerHTML = returnHtml;
          console.log('Container HTML updated successfully');
        }

        this.equalHeights();
        this.hideEmptyMetafieldRows();
      } catch (error) {
        console.error('Error fetching products for comparison:', error);
        if (this.container && this.container instanceof HTMLElement) {
          const errorText = window.theme && window.theme.strings && window.theme.strings.compare ? window.theme.strings.compare.errorLoadingComparison : 'Fehler beim Laden der Vergleichsdaten';
          this.container.innerHTML = `<div class="compare-lightbox--table"><div class="compare-lightbox--row">${errorText}</div></div>`;
        }
      } finally {
        this.classList.remove('loading');
        console.log('Loading class removed');
      }
    }
    /**
     * @param {string} html - The HTML string to extract from
     * @param {string} selector - The CSS selector to look for
     * @returns {string} - The extracted HTML content
     */
    getSectionInnerHTML(html, selector) {
      try {
        console.log(`\n=== Extracting section inner HTML with selector: ${selector} ===`);

        // 首先检查HTML是否为空
        if (!html || html.length === 0) {
          console.error('Received empty HTML');
          return '';
        }

        // 检查返回的HTML是否包含错误信息
        if (html.includes('404') || html.includes('Page Not Found')) {
          console.error('Received 404 error page');
          return '';
        }

        // 创建一个临时div来解析HTML（适用于片段和完整文档）
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // 适配新创建的product.compare.liquid模板结构
        // 首先尝试直接查找compare-lightbox--table
        let tableElement = tempDiv.querySelector('.compare-lightbox--table');
        if (tableElement) {
          console.log('直接找到compare-lightbox--table元素');
          return tableElement.outerHTML;
        }

        // 尝试查找product-compare-table元素
        let productCompareElement = tempDiv.querySelector('product-compare-table');
        if (productCompareElement) {
          console.log('找到product-compare-table元素');
          return productCompareElement.innerHTML;
        }

        // 尝试查找整个compare-lightbox--data容器
        let dataContainer = tempDiv.querySelector('.compare-lightbox--data');
        if (dataContainer) {
          console.log('找到compare-lightbox--data容器');
          return dataContainer.innerHTML;
        }

        // 简化提取逻辑，尝试多种选择器
        const selectors = [
          '.compare-lightbox--table',
          '.compare-lightbox--data',
          'section.main-product-compare-section',
          '.product-compare-section',
          '[class*="compare"]',
          'section[id*="main-product-compare"]'
        ];

        for (const sel of selectors) {
          console.log(`Trying selector: ${sel}`);
          const element = tempDiv.querySelector(sel);
          if (element) {
            console.log(`Found element with selector: ${sel}`);

            // 如果找到的是容器元素，尝试提取内部的表格
            if (sel === '.compare-lightbox--data' || sel.includes('section')) {
              const innerTable = element.querySelector('.compare-lightbox--table');
              if (innerTable) {
                console.log('Found compare-lightbox--table inside container');
                return innerTable.outerHTML;
              }
            }

            return element.outerHTML;
          }
        }

        // 调试：输出可用的class列表
        const allElements = tempDiv.querySelectorAll('*');
        const classList = Array.from(allElements).map(el => el.className).filter(c => c).join(', ');
        console.log(`Available classes in HTML: ${classList}`);

        // 调试：输出HTML的前1000个字符
        console.log(`HTML snippet (first 1000 chars): ${html.substring(0, 1000)}...`);

        // 尝试使用正则表达式作为最后手段
        console.log('Trying regex extraction as final fallback');
        const regexPatterns = [
          /<div[^>]*class=["'][^"']*compare-lightbox--table[^"']*["'][^>]*>([\s\S]*?)<\/div>/i,
          /<div[^>]*class=["'][^"']*compare-lightbox--data[^"']*["'][^>]*>([\s\S]*?)<\/div>/i,
          /<product-compare-table[^>]*>([\s\S]*?)<\/product-compare-table>/i,
          /<(?:section|div)[^>]*class=["'][^"']*compare[^"']*["'][^>]*>([\s\S]*?)<\/(?:section|div)>/i
        ];

        for (const regex of regexPatterns) {
          const match = html.match(regex);
          if (match && match[0]) {
            console.log('Regex extraction successful');
            return match[0];
          }
        }

        // 如果所有尝试都失败
        console.error('Could not extract compare table content from HTML');
        // 输出更多信息以便调试
        console.log('HTML length:', html.length);
        console.log('Available classes in HTML:', [...new Set(
          html.match(/class=["'][^"']*["']/g)?.map(m => m.replace(/class=["']|['"]$/g, '')) || []
        )].join(', '));

        // 输出HTML的开始部分以便调试
        console.log('HTML snippet (first 1000 chars):', html.substring(0, 1000));

        return '';
      } catch (e) {
        console.error('Error parsing HTML:', e);
        // 输出错误发生时的HTML片段
        console.log('HTML at error (first 1000 chars):', html.substring(0, 1000));
        return '';
      }
    }
    equalHeights() {
      for (let i = 0; i < 10; i++) {
        this.equalizeTableRowHeightAcrossTables(i);
      }
    }

    // Hide metafield rows that have "N/A" for all products
    hideEmptyMetafieldRows() {
      if (!this.container) return;

      // Get all metafield labels
      const metafieldLabels = new Set();
      const metafieldItems = this.container.querySelectorAll('.product-card-metafield-item');

      metafieldItems.forEach(item => {
        const label = item.querySelector('.product-card-metafield-label');
        if (label) {
          metafieldLabels.add(label.textContent.trim());
        }
      });

      // For each unique label, check if all products have "N/A"
      metafieldLabels.forEach(label => {
        const rowsWithLabel = Array.from(metafieldItems).filter(item => {
          const itemLabel = item.querySelector('.product-card-metafield-label');
          return itemLabel && itemLabel.textContent.trim() === label;
        });

        // Check if all values are "N/A"
        const allNA = rowsWithLabel.every(row => {
          const value = row.querySelector('.product-card-metafield-value');
          return value && value.textContent.trim() === 'N/A';
        });

        // Hide all rows with this label if all are "N/A"
        if (allNA) {
          rowsWithLabel.forEach(row => {
            if (row instanceof HTMLElement) {
              row.style.display = 'none';
            }
          });
        } else {
          // Ensure visible if at least one has a value
          rowsWithLabel.forEach(row => {
            if (row instanceof HTMLElement) {
              row.style.display = 'block';
            }
          });
        }
      });
    }
    /**
     * @param {number} rowPosition - The position of the row to equalize heights for
     */
    equalizeTableRowHeightAcrossTables(rowPosition) {
      if (!this.container) return;

      const tables = this.container.querySelectorAll('.compare-lightbox--table');
      if (!tables || tables.length === 0) return;

      // Find the maximum height for the specified row position across all tables
      let maxHeight = 0;

      // Iterate over each table to find the maximum height
      tables.forEach(table => {
        if (!table) return;

        const rows = table.querySelectorAll('.compare-lightbox--row');

        // Ensure the row at the specified position exists
        if (rows.length > rowPosition && rows[rowPosition]) {
          const rowHeight = rows[rowPosition].clientHeight;
          maxHeight = Math.max(maxHeight, rowHeight);
        }
      });

      // Set all rows at the specified position to the maximum height
      if (maxHeight > 0) {
        tables.forEach(table => {
          if (!table) return;

          const rows = table.querySelectorAll('.compare-lightbox--row');

          // Ensure the row at the specified position exists
          if (rows.length > rowPosition && rows[rowPosition]) {
            const row = rows[rowPosition];
            if (row instanceof HTMLElement) {
              row.style.height = `${maxHeight}px`;
            }
          }
        });
      }
    }
  }
  customElements.define('product-compare-table', ProductCompareTable);
}